import { AppConfig } from '@/config/appConfig';

export const msalConfig = {
  auth: {
    clientId: '57cbe5ae-1b55-4049-b707-d7fef5eb0cf9',
    authority: 'https://login.microsoftonline.com/common/',
    redirectUri: `${AppConfig.webUrl}/auth/login`,
    postLogoutRedirectUri: `${AppConfig.webUrl}/auth/login`,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  // system: {
  //     loggerOptions: {
  //         loggerCallback: (level, message, containsPii) => {
  //             if (containsPii) {
  //                 return;
  //             }
  //             switch (level) {
  //                 case msal.LogLevel.Error:
  //                     console.error(message);
  //                     return;
  //                 case msal.LogLevel.Info:
  //                     console.info(message);
  //                     return;
  //                 case msal.LogLevel.Verbose:
  //                     console.debug(message);
  //                     return;
  //                 case msal.LogLevel.Warning:
  //                     console.warn(message);
  //                     return;
  //             }
  //         }
  //     }
  // }
};

export const msLoginRequest = {
  // scopes: ["User.Read","openid"]
  scopes: ['User.Read', 'openid', 'profile', 'email'],
  prompt: 'select_account',
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const msTokenRequest = {
  scopes: ['User.Read', 'Mail.Read'],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};
